import React from "react"
import * as AppConstants from "../../../utility/AppConstants"
import * as Utility from "../../../utility/Utility"
import "Css/table.css"
interface HeaderTotaliProps {
    codIsa: string | null | undefined
    macroarea: string | null | undefined
    anni: string[]
    codici: string[]
}

function HeaderTotali(props: HeaderTotaliProps) {
    let infoCodIsa =
        props.codIsa != "@@" &&
        props.codIsa != "" &&
        [...new Set(props.codici)].length > 1
            ? props.codici.map((cod) => ` (${cod})`)
            : ["", "", ""]

    return (
        <React.Fragment>
            <tr>
                <th style={{ width: "20rem" }}>
                    {Utility.getValoreHeader(props.codIsa, props.macroarea, true)}{" "}
                </th>
                <th className="th-statistiche">
                    {props.anni[0]}
                    {infoCodIsa[0]}
                </th>
                <th className="th-statistiche">
                    {props.anni[1]}
                    {infoCodIsa[1]}
                </th>
                <th className="th-statistiche">
                    {props.anni[2]}
                    {infoCodIsa[2]}
                </th>
            </tr>
        </React.Fragment>
    )
}
export default HeaderTotali
